// Libs
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import isBetween from 'dayjs/plugin/isBetween';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/vi';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';

// Constants
import { LOCAL_TIMEZONE } from '@app/constants/localStorage';
import { DEFAULT_TIMEZONE } from '@app/constants/common';

dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(
  window.localStorage.getItem(LOCAL_TIMEZONE) || DEFAULT_TIMEZONE
);

const dayjsWithTz = (...arg) => dayjs(...arg).tz();

export class Dates {
  static setLocale(locale) {
    dayjs.locale(locale);
  }

  static getToday() {
    return dayjsWithTz();
  }

  static getClearDate() {
    return this.getToday().hour(0).minute(0).second(0).millisecond(0);
  }

  static getMonths() {
    return dayjs.months();
  }

  static getDays() {
    return dayjs.weekdaysShort();
  }

  static getDate(date) {
    return dayjsWithTz(date);
  }

  static format(date, query) {
    if (typeof date === 'string' || typeof date === 'number') {
      return dayjsWithTz(date).format(query);
    } else {
      return date.format(query);
    }
  }
}
